import { render } from "./forgot-password.vue?vue&type=template&id=270811fa"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__